module.exports = __webpack_public_path__ + "img/6b_Attendance.226ce71d.png";